import Grid from '@material-ui/core/Grid';
import { styles } from './Grid.style';
import withStyles from '@material-ui/core/styles/withStyles';

const StyledGrid = withStyles(styles, { name: 'MuiGrid' })(Grid);
export default StyledGrid;
